import Link from 'next/link';
import React, { FC, useEffect, useState } from 'react';

//styles
import styles from './footer-masthead.module.scss';
import { useIntl } from 'react-intl';
import { isPharmaprixBanner } from '@/utils';

const FooterMasthead: FC = () => {
  const { formatMessage } = useIntl();

  /* We want Pharmaprix/SDM to follow the hostname, not locale */
  const [siteName, setSiteName] = useState('Shoppers Drug Mart');

  useEffect(() => {
    setSiteName(typeof window !== 'undefined' && isPharmaprixBanner() ? 'Pharmaprix' : 'Shoppers Drug Mart');
  }, []);

  return (
    <div className={styles.footerMastheadContainer} data-testid="footer-masthead">
      <div className={styles.footerMastheadWrapper}>
        <div className={styles.copyRightContainer}>
          <p className={styles.copyRight}>
            {formatMessage({ id: 'copyright' })} &copy; 2019 {siteName} Inc.
          </p>
        </div>
        <div className={styles.privacyContainer}>
          <Link href={`https://corporate.shoppersdrugmart.ca/en-ca/legal`}>{formatMessage({ id: 'terms' })}</Link>
          <p>&nbsp;|&nbsp;</p>
          <Link href={`https://www.loblaw.ca/en/privacy.html`}>{formatMessage({ id: 'privacy' })}</Link>
        </div>
      </div>
    </div>
  );
};

export default FooterMasthead;
